// fork overlay: fork-owned helper (no chatwoot-br precedent — upstream inlined keys into inboxMgmt.json directly)
// Recursive deep-merge: plain objects merged key-wise; arrays replaced wholesale; scalars overwrite.
// Prototype-safe: iterates only own-enumerable keys via Object.keys(source).
//
// IMPORTANT: This function mutates target in place (and returns it for chaining).
// Do NOT pass a frozen or const-shared object as `target` — at minimum pass a spread
// copy (e.g. `deepMerge({ ...ossLocale }, forkLocale)`). Call sites in en/index.js
// already spread the OSS locale object before merging fork keys.
export default function deepMerge(target, source) {
  for (const key of Object.keys(source)) {
    if (key === '__proto__' || key === 'constructor') continue;
    const s = source[key];
    const t = target[key];
    if (s && typeof s === 'object' && !Array.isArray(s)
        && t && typeof t === 'object' && !Array.isArray(t)) {
      deepMerge(t, s);
    } else {
      target[key] = s;
    }
  }
  return target;
}
